import React,{useContext,useState} from 'react';
import Typography from '@visa/vds/typography'
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import {PageHelper} from '../../../_helpers/PageHelper';
import {adminService} from '../../../services/admin.service';
import ManageUsersTable from './ManageUsersTable';
import ManageUserDialog from './ManageUserDialog';
import {GlobalAlertContext} from '../../../context/GlobalAlertContext';
import { TableHelper } from "../../../_helpers/TableHelper";
import { AuthContext } from '../../../context/AuthContext';
import MCSLoading from 'components/MCSLoading';
import { FileHelper } from "_helpers/FileHelper";

function ManageUsers(props){
    
    const PAGE_SIZE = 10
    let colHeaders = [  
        {displayName:"User ID", name:"volUserId",orderable: true, defaultOrdered: true},
        {displayName:"Name",name:"firstName",orderable: true},
        {displayName:"Organization",name:"organization.organizationName",orderable: true},
        {displayName:"BID",name:"organization.bid",orderable: true}, 
        {displayName:"Region",name:"organization.region.regionName",orderable: true},
        {displayName:"Country (User ID)",name:"country.countryName",orderable: true},  
        {displayName:"Role",name:"role.roleName",orderable: true},
        {displayName:"Last Updated By",name:"lastUpdatedBy",orderable: true},
        {displayName:"Last Updated On",name:"lastUpdatedOn",orderable: true},
        {displayName:"",name:"actions",orderable:false}
    ];
    const [countries,setCountries] = useState(null);

    const [loading, setLoading] = useState(true);
    const [selectedUser,setSelectedUser] = useState(null);
    const [usersData,setUsersData] = useState(null);
    const [userTotalPages,setUserTotalPages] = useState(0)
    const [ordered,setOrdered] = useState("");
    const [selectedPage,setSelectedPage] = useState(1)
    const [searchVal, setSearchVal] = useState("");
    const [isDsc,setDsc] = useState(false);
    const queryString = require('query-string');
    const currentUserData = useContext(AuthContext)
    
    const GetAllCountries = async () => {
        const response = await adminService.GetAllCountries();
        setCountries(response.result);
    }

    const handleUsersPageChange = async (page,search=null,orderBy=null,isDsc=false) => {
        setLoading(true);
        let skipCount = PageHelper.GetSkipCount(PAGE_SIZE,page)
        const Users = await adminService.AdminGetUsers(currentUserData.user.entitleId,skipCount,search,orderBy,isDsc)

        setUsersData(Users.data.result.items);
        setUserTotalPages(PageHelper.GetTotalCountToPages(PAGE_SIZE,Users.data.result.totalCount));
        setLoading(false);
    }

    const tablesRefresh= async() =>{
        handleUsersPageChange(selectedPage,searchVal,ordered,isDsc);
    }

    const handleExportAllUsers = async (alertObj) => {
        setLoading(true);
        let res = await adminService.ExportAllUsers();
        FileHelper.DownloadFile(res);
        setLoading(false);
    }

    React.useEffect(()=>{
        var query = props.location.search;
        var initialSearchValue = "";

        if(query.trim() != ""){
            var queryItems = queryString.parse(query);
            console.log(queryItems);
            if (queryItems.organizationName != null && queryItems.organizationName != ""){
                setSearchVal(queryItems.organizationName)
                initialSearchValue = queryItems.organizationName
            }
        }

        var defaultSortedCol = TableHelper.GetDefaultOrderedColumn(colHeaders);
        if(defaultSortedCol != null){
            setOrdered(defaultSortedCol.name);
            handleUsersPageChange(1, initialSearchValue,defaultSortedCol.name,false);
        }else{
            handleUsersPageChange(1, initialSearchValue);
        }
        GetAllCountries();
    },[]);

    return (
    <GlobalAlertContext.Consumer>
        {
            alertObj=>(
                <AuthContext.Consumer>{
                    currentUser=>(
                        <>
                        <ManageUserDialog countries={countries} alertObj={alertObj} tablesRefresh={tablesRefresh} user={selectedUser} openUserAccessDialog={selectedUser!= null} setSelectedUser={setSelectedUser} currentUser={currentUser}/>
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1">Manage Users</Typography>
                                </Col>
                            </Row>
        
                            <Row>
                                {loading 
                                ? <MCSLoading/>
                                : <ManageUsersTable 
                                    colHeaders={colHeaders} PAGE_SIZE={10} fetch={handleUsersPageChange}
                                    ordered={ordered} setOrdered={setOrdered} 
                                    selectedPage={selectedPage} setSelectedPage={setSelectedPage}
                                    searchVal={searchVal} setSearchVal={setSearchVal}
                                    isDsc={isDsc} setDsc={setDsc}
                                    setSelectedUser={setSelectedUser} data={usersData} totalPages={userTotalPages}
                                    handleExportUsers={handleExportAllUsers}/>
                                }    
                            </Row>
                        </Grid>
                        </>
                    )
                }</AuthContext.Consumer>

            )
        }
    </GlobalAlertContext.Consumer>
    );
    
  }


export default ManageUsers;
